export const URL_MAZE_USERS = "https://carlos-ruiz-back.onrender.com/users";
export const URL_MAZE_ESCAPEROOMS =
  "https://carlos-ruiz-back.onrender.com/escaperooms";
export const URL_MAZE_RESERVATIONS =
  "https://carlos-ruiz-back.onrender.com/reservations";
